import React from "react";
import CustomBlockUserPopup from "../../components/CustomBlockUserPopup/CustomBlockUserPopup";
import CustomMultipleSessionPopUp from "../../components/CustomMultipleSessionPopUp/CustomMultipleSessionPopUp";
import useAuthGuardBootstrap from "./useAuthGuardBootstrap";

type T_AuthBootstrapBridgeProps = {
  onResult: (status: boolean) => void;
};

const AuthBootstrapBridge: React.FC<T_AuthBootstrapBridgeProps> = ({
  onResult,
}) => {
  const {
    authPassed,
    popupError,
    showPopup,
    openBlockedUserPopup,
    logoutPreviousSession,
    handleBlockedUserPopupClose,
    triggerUserLogout,
  } = useAuthGuardBootstrap({
    initFlag: true,
    showCustomLoading: true,
  });

  onResult(authPassed);

  return (
    <>
      {popupError && (
        <CustomMultipleSessionPopUp
          gotoLogin={triggerUserLogout}
          logoutPreviousSession={() => logoutPreviousSession()}
          open={showPopup}
        />
      )}
      {openBlockedUserPopup && (
        <CustomBlockUserPopup
          open={openBlockedUserPopup}
          handleOpen={handleBlockedUserPopupClose}
        />
      )}
    </>
  );
};

export default AuthBootstrapBridge;
